import ColorBackground from "./color";
import GradientBackground from "./gradient";
import ImageBackground from "./image";
import VideoBackground from "./video";

class BackgroundLayer {
    constructor(domElement) {
        this._domElement = domElement

        this._container = document.createElement("div");
        this._container.classList.add("background");
        this._colorDiv = document.createElement("div");
        this._colorDiv.classList.add("color-background");
        this._imageCanvas = document.createElement("canvas");
        this._imageCanvas.classList.add("image-background");
        this._videoElem = document.createElement("div");
        this._videoElem.classList.add("video-background");

        this._color = new ColorBackground(this._colorDiv);
        this._gradient = new GradientBackground(this._colorDiv);
        this._image = new ImageBackground(this._imageCanvas);
        this._video = new VideoBackground(this._videoElem);

        this._domElement.appendChild(this._container);
        this._container.appendChild(this._colorDiv);
        this._container.appendChild(this._imageCanvas);
        this._container.appendChild(this._videoElem);

        this._type = "none";

        this._opacity = 1;
    }

    get opacity() { return this._opacity; }

    set opacity(value) {
        this._opacity = value;
        this._container.style.opacity = value;
    }

    setBackground({
        type = "none",
        color1 = null,
        color2 = null,
        gradientEnabled = false,
        gradientType = "horizontal",
        image = null,
        imageOffsetX = 0,
        imageOffsetY = 0,
        imageScaleX = 1,
        imageScaleY = 1,
        fitMode = 'cover',
    }) {
        this._type = type;
        this._updateDomVisibility();

        switch (type) {
            case "color":
                if (gradientEnabled) {
                    this._gradient.setType(gradientType);
                    this._gradient.setColors(color1, color2);
                } else this._color.setColor(color1);
                break;
            case "image":
                this._image.setImage(image);
                this._image.setOffset(imageOffsetX, imageOffsetY);
                this._image.setScale(imageScaleX, imageScaleY);
                this._image.setFitMode(fitMode);
                this._image.setTiling(fitMode === 'cover');
                break;
            case "video":
                this._video.setVideo(image);
                this._video.setFitMode(fitMode);
                break;
        }
    }

    _updateDomVisibility() {
        let type = this._type;

        this._colorDiv.classList.toggle("hidden", type !== "color");
        this._imageCanvas.classList.toggle("hidden", type !== "image");
        this._videoElem.classList.toggle("hidden", type !== "video");
    }

    updateSize() {
        const size = this._domElement.getBoundingClientRect();
        const width = Math.round(size.width * devicePixelRatio);
        const height = Math.round(size.height * devicePixelRatio);

        this._image.setSize(width, height);
        this._video.setSize(width, height);
    }

    setRenderOrder(order) { this._container.style.zIndex = order; }
    update() { }
};

export default BackgroundLayer;
export { BackgroundLayer };
